/*
 * @Description:
 * @Autor: lichao
 * @Date: 2021-11-26 16:47:46
 * @LastEditors: lichao
 * @LastEditTime: 2021-12-10 09:23:51
 */
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import NavigationBar from "./components/NavigationBar";
import SiteMapFooter from "./components/SiteMapFooter";

import routes from "./router/index";

const CAPTCHA_VERIFIED_PATH = "captcha_verified_path";

/** 验证码开启时间段：每天 20:00 至次日 08:30（本地时间） */
function isCaptchaTimeWindow() {
  const now = new Date();
  const h = now.getHours();
  const m = now.getMinutes();
  if (h >= 20) return true; // 20:00 - 23:59
  if (h < 8) return true;   // 00:00 - 07:59
  if (h === 8 && m <= 30) return true; // 08:00 - 08:30
  return false;
}

/** 当前路径是否在当次验证通过范围内（含同一模块子路径，如 /foundation 与 /foundation/introduce 只验证一次） */
function isPathVerified(pathname, verifiedPath) {
  if (!verifiedPath) return false;
  if (pathname === verifiedPath) return true;
  if (pathname.startsWith(verifiedPath + "/") || verifiedPath.startsWith(pathname + "/")) return true;
  return false;
}

/** 路由守卫：仅在时间段内生效；未在验证码页且当前路径未在当次验证通过范围内时，先跳验证码页 */
function AppContent() {
  const location = useLocation();
  const pathname = location.pathname;

  const verifiedPath =
    typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem(CAPTCHA_VERIFIED_PATH)
      : null;
  const needVerify =
    isCaptchaTimeWindow() &&
    pathname !== "/verify" &&
    !isPathVerified(pathname, verifiedPath);

  if (needVerify) {
    return (
      <Redirect
        to={{
          pathname: "/verify",
          state: { from: pathname },
        }}
      />
    );
  }

  let isUrl = window.location.href.includes('bjftcf.com');
  let isInternalUse = window.location.href.includes('ftAdskcE2d5fDevUuLilLw4A8f');
  let isQuestionnaireSurvey = window.location.href.includes('questionnaire');
  let noNavigationBar = isInternalUse || isQuestionnaireSurvey;

  return (
    <>
      {isUrl || noNavigationBar ? '' : <NavigationBar />}
      <Switch>
        {routes.map((r, i) => {
          if (!r.path) {
            return (
              <Route
                key={i}
                render={() => {
                  document.title = (r.meta && r.meta.name);
                  return <r.component meta={r.meta} />;
                }}
              />
            );
          }
          if (r.exact) {
            return (
              <Route
                key={i}
                path={r.path}
                render={(props) => {
                  document.title = r.meta.name;
                  return <r.component meta={r.meta} />;
                }}
                exact={r.exact}
              ></Route>
            );
          } else {
            return (
              <Route
                key={i}
                path={r.path}
                exact={r.exact}
                render={(props) => {
                  document.title = r.meta.name;
                  return <r.component meta={r.meta} />;
                }}
              ></Route>
            );
          }
        })}
        {/*如果是公益基金会的网址，则默认跳转到公益基金会的页面*/}
        {
          isUrl?<Redirect path="/" to="/foundation/introduce"></Redirect>:<Redirect path="/" to="/home"></Redirect>
        }

      </Switch>
      {noNavigationBar ? '' : <SiteMapFooter />}
    </>
  );
}

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
